export const LEAD_SOURCE = "LEAD_SOURCE";
export const APARTMENT_DROPDOWN = "APARTMENT_DROPDOWN";
